import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chat');
import { OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface ChatSource { number: number; title: string; url: string; path: string; community: string; }
interface ChatMessage { sources?: ChatSource[]; id: number; role: 'user' | 'assistant'; text: string; displayText?: string; state?: 'streaming' | 'complete' | 'stopped' | 'error'; error?: string; }

@Component({
    selector: 'wiz-page-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chat/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
  font-family: "SUIT", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 16px;
  color: #172b45;
  -webkit-font-smoothing: antialiased;
  --blue: #1853ad;
  --navy: #102c50;
  --line: #d7e0ec;
  --muted: #52647a;
  --header-height: 80px;
}

* {
  box-sizing: border-box;
}

button, textarea, input {
  font: inherit;
}

button {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 160ms ease, color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

button:disabled {
  cursor: not-allowed;
}

button:focus-visible, a:focus-visible, summary:focus-visible, input:focus-visible {
  outline: 3px solid #2765bc;
  outline-offset: 3px;
}

svg {
  display: block;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.chat-stage {
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  background: #f4f7fb;
}

.chat-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.chat-header {
  height: var(--header-height);
  flex: 0 0 var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--line);
  background: #fff;
  z-index: 3;
}

.header-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-mark {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 14px;
  color: #fff;
  background: var(--navy);
  box-shadow: 0 3px 8px rgba(16, 44, 80, 0.0784313725);
}

.brand-mark svg {
  width: 28px;
  height: 28px;
}

.header-title h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 750;
  line-height: 1.3;
  letter-spacing: -0.5px;
  color: var(--navy);
  white-space: nowrap;
}

.header-title h1 span {
  font-size: 17px;
  font-weight: 600;
  margin-left: 6px;
}

.header-actions {
  display: flex;
  gap: 6px;
}

.icon-button {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border: 1px solid #dce4ee;
  border-radius: 12px;
  background: #fff;
  color: #324c6d;
}

.icon-button:hover, .icon-button[aria-expanded=true] {
  color: var(--blue);
  background: #eaf1fc;
  border-color: #acc4e6;
}

.icon-button:active, .send-button:active {
  transform: scale(0.95);
}

.connection-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 18px;
  font-size: 14px;
  line-height: 1.6;
  background: #fff6e4;
  color: #73500e;
  border-bottom: 1px solid #e9d6ad;
  flex-shrink: 0;
}

.connection-notice button {
  min-height: 40px;
  padding: 6px;
  border: 0;
  background: transparent;
  color: #644409;
  font-weight: 650;
  white-space: nowrap;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.conversation-wrap {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
}

.conversation-scroll {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #a8b8cc transparent;
}

.conversation-scroll::-webkit-scrollbar {
  width: 6px;
}

.conversation-scroll::-webkit-scrollbar-thumb {
  background: #a8b8cc;
  border-radius: 6px;
}

.welcome {
  max-width: 620px;
  margin: 0 auto;
  padding: 30px 24px 28px;
  animation: enter 240ms ease both;
}

.welcome h2 {
  margin: 0;
  color: var(--navy);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: -0.8px;
}

.welcome > p {
  margin: 12px 0 24px;
  color: #465b74;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
}

.message-list {
  max-width: 820px;
  margin: 0 auto;
  padding: 24px 20px;
}

.message {
  min-width: 0;
  margin-bottom: 24px;
  animation: enter 220ms ease both;
}

.message:last-child {
  margin-bottom: 4px;
}

.assistant-message {
  background: #fff;
  border: 1px solid #dbe3ed;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 3px 8px rgba(16, 44, 80, 0.0156862745);
}

.assistant-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  color: #173b6c;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
}

.assistant-emblem {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  color: #fff;
  background: var(--navy);
  border-radius: 9px;
}

.assistant-emblem svg {
  width: 19px;
  height: 19px;
}

.message-text {
  margin: 0;
  overflow-wrap: anywhere;
  word-break: keep-all;
  color: #1c304a;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
  letter-spacing: -0.12px;
}

.message-text.is-streaming::after {
  content: "";
  display: inline-block;
  width: 3px;
  height: 16px;
  background: var(--blue);
  border-radius: 2px;
  vertical-align: -2px;
  margin-left: 4px;
  animation: cursor-pulse 1s ease infinite;
}

.user-message {
  display: flex;
  justify-content: flex-end;
}

.user-message .message-body {
  max-width: 91%;
  padding: 13px 17px;
  border-radius: 18px 18px 5px 18px;
  background: #194f9f;
}

.user-message .message-text {
  white-space: pre-wrap;
  color: #fff;
  line-height: 1.7;
}

.message-error {
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 8px;
  color: #923717;
  background: #fff3ec;
  font-size: 14px;
  line-height: 1.65;
}

.message-tools {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.text-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 40px;
  padding: 7px 10px;
  margin-left: -4px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #465b73;
  font-size: 14px;
  font-weight: 500;
}

.text-button svg {
  width: 18px;
  height: 18px;
}

.text-button:hover {
  background: #eef3fa;
  border-color: #d5e0ef;
  color: #164b91;
}

.text-button:disabled {
  opacity: 0.5;
}

.thinking {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 36px;
  color: #4d6480;
  font-size: 15px;
}

.thinking-dots {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.thinking-dots b {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #285c9e;
  animation: dot-pulse 1.3s ease-in-out infinite;
}

.thinking-dots b:nth-child(2) {
  animation-delay: 0.15s;
}

.thinking-dots b:nth-child(3) {
  animation-delay: 0.3s;
}

.jump-latest {
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 10px 16px;
  border: 1px solid #b8cbe3;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(24, 60, 104, 0.1254901961);
  font-size: 14px;
  font-weight: 500;
  color: #173f76;
  white-space: nowrap;
}

.jump-latest svg {
  width: 18px;
  height: 18px;
}

.jump-latest:hover {
  background: #edf4ff;
}

.composer-area {
  flex-shrink: 0;
  padding: 14px 18px 12px;
  border-top: 1px solid #d4dfec;
  background: #fff;
  z-index: 2;
}

.composer-tools {
  display: flex;
  justify-content: flex-end;
  max-width: 780px;
  margin: -8px auto 4px;
}

.composer-tools .text-button {
  min-height: 44px;
  margin: 0;
}

.composer-box {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  max-width: 780px;
  margin: 0 auto;
  padding: 9px;
  border: 1.5px solid #9dacc1;
  border-radius: 16px;
  background: #fff;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.composer-box:focus-within {
  border-color: #215caa;
  box-shadow: 0 0 0 3px rgba(33, 92, 170, 0.0784313725);
}

textarea {
  display: block;
  flex: 1;
  min-width: 0;
  width: 100%;
  min-height: 44px;
  max-height: clamp(44px, 20dvh, 120px);
  overflow-y: auto;
  resize: none;
  margin: 0;
  padding: 9px 2px 7px 6px;
  border: 0;
  outline: none;
  box-shadow: none;
  background: transparent;
  color: #182d48;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
}

textarea::placeholder {
  color: #5c6d83;
  font-weight: 400;
  opacity: 1;
}

.send-button {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border: 0;
  border-radius: 12px;
  background: var(--blue);
  color: #fff;
}

.send-button svg {
  width: 23px;
  height: 23px;
}

.send-button:hover {
  background: #113f88;
}

.send-button:disabled {
  background: #e3e9f1;
  color: #62758e;
}

.stop-button {
  background: #dce9fc;
  color: #154a95;
}

.stop-button svg {
  width: 19px;
  height: 19px;
}

.stop-button:hover {
  background: #c7daf6;
}

.composer-meta {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 780px;
  min-height: 16px;
  margin: 9px auto 0;
  color: #56677d;
  font-size: 12px;
  line-height: 1.4;
}

.input-count {
  margin-right: auto;
  font-variant-numeric: tabular-nums;
}

.toast {
  position: absolute;
  bottom: 135px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: calc(100% - 32px);
  padding: 11px 16px;
  border-radius: 11px;
  background: #15365f;
  color: #fff;
  font-size: 14px;
  line-height: 1.6;
  box-shadow: 0 5px 18px rgba(16, 44, 80, 0.1254901961);
  z-index: 8;
  animation: fade-in 160ms ease both;
}

.message-sources {
  margin: 18px 0 2px;
  border-top: 1px solid #dce4ee;
  color: #244c81;
}
.message-sources summary {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 12px 0 6px;
  cursor: pointer;
  list-style: none;
  font-size: 14px;
  font-weight: 600;
}
.message-sources summary::-webkit-details-marker {
  display: none;
}
.message-sources summary svg {
  width: 18px;
  height: 18px;
}
.message-sources .source-chevron {
  margin-left: auto;
  transition: transform 160ms;
}
.message-sources[open] .source-chevron {
  transform: rotate(180deg);
}
.message-sources a {
  display: block;
  padding: 12px;
  margin: 7px 0;
  border: 1px solid #d5e0ee;
  border-radius: 10px;
  background: #f5f8fd;
  color: #174d98;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.65;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.message-sources a:hover {
  background: #eaf2ff;
  border-color: #a5bee0;
}
.message-sources a:hover span {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.message-sources small {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #52647a;
  margin-top: 5px;
}

:host ::ng-deep .formatted-answer p {
  margin: 0 0 14px;
}
:host ::ng-deep .formatted-answer p:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .formatted-answer strong {
  font-weight: 700;
  color: #112b4a;
}
:host ::ng-deep .formatted-answer h3 {
  font-size: 17px;
  line-height: 1.6;
  font-weight: 700;
  color: #112b4a;
  margin: 20px 0 10px;
}
:host ::ng-deep .formatted-answer h3:first-child {
  margin-top: 0;
}
:host ::ng-deep .formatted-answer ul, :host ::ng-deep .formatted-answer ol {
  padding-left: 23px;
  margin: 12px 0 16px;
}
:host ::ng-deep .formatted-answer ul {
  list-style: disc outside;
}
:host ::ng-deep .formatted-answer ol {
  list-style: decimal outside;
}
:host ::ng-deep .formatted-answer li {
  margin-bottom: 9px;
  padding-left: 3px;
}
:host ::ng-deep .formatted-answer li::marker {
  color: #285691;
  font-weight: 650;
}
:host ::ng-deep .formatted-answer code {
  font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
  font-size: 0.94em;
  padding: 2px 5px;
  border-radius: 5px;
  color: #164980;
  background: #eaf0f8;
  overflow-wrap: anywhere;
}
:host ::ng-deep .formatted-answer pre {
  margin: 14px 0 18px;
  padding: 14px;
  border: 1px solid #cbd8e9;
  border-radius: 10px;
  background: #f0f4fa;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.75;
}
:host ::ng-deep .formatted-answer pre code {
  padding: 0;
  background: transparent;
  color: #142e50;
  font-size: 15px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes dot-pulse {
  0%, 80%, 100% {
    opacity: 0.4;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
@keyframes cursor-pulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@media (max-width: 360px) {
  .chat-header {
    padding: 14px 12px;
    gap: 8px;
  }
  .header-identity {
    gap: 9px;
  }
  .brand-mark {
    width: 40px;
    height: 40px;
  }
  .header-title h1 {
    font-size: 18px;
  }
  .header-title h1 span {
    font-size: 16px;
  }
  .header-actions {
    gap: 4px;
  }
  .message-list {
    padding: 20px 12px;
  }
  .assistant-message {
    padding: 15px;
  }
  .welcome {
    padding: 24px 18px;
  }
  .composer-area {
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (max-width: 480px) {
  :host {
    --header-height: 68px;
  }
  .chat-header {
    padding: 10px 14px;
    gap: 8px;
  }
  .header-identity {
    gap: 9px;
  }
  .brand-mark {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
  .header-title h1 {
    font-size: 18px;
  }
  .header-title h1 span {
    font-size: 16px;
  }
  .header-actions {
    gap: 4px;
  }
  .message-list {
    padding: 18px 12px;
  }
  .assistant-message {
    padding: 14px;
  }
  .assistant-label {
    margin-bottom: 10px;
  }
  .message {
    margin-bottom: 18px;
  }
  .composer-area {
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (pointer: coarse) {
  .keyboard-hint {
    display: none;
  }
  .composer-meta {
    min-height: 0;
    margin-top: 0;
  }
  .input-count {
    margin-top: 8px;
  }
  .composer-area {
    padding-bottom: max(14px, env(safe-area-inset-bottom));
  }
}
@media (max-height: 700px) {
  .welcome {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .welcome h2 {
    font-size: 24px;
  }
  .welcome > p {
    margin: 10px 0 20px;
    line-height: 1.6;
  }
}
@media (max-height: 540px) {
  .welcome {
    padding-top: 22px;
  }
  .composer-meta {
    display: none;
  }
  .composer-area {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
@media (max-height: 600px) and (max-width: 480px) {
  .welcome {
    padding: 14px 16px;
  }
  .welcome h2 {
    font-size: 22px;
    line-height: 1.4;
    margin-bottom: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}`],
})
export class PageChatComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}
    @ViewChild('messageScroll') messageScroll?: ElementRef<HTMLElement>;
    @ViewChild('composer') composer?: ElementRef<HTMLTextAreaElement>;
    public knowledgeReady = true;
    public input = '';
    public loading = false;
    public followLatest = true;
    public copiedId: number | null = null;
    public messages: ChatMessage[] = [];
    public notice = '';
    private portalCommunity: string | null = null;
    private portalReady = false;
    private readonly portalOrigin = 'https://portal.gsdc.kr';
    private readonly communities = ['ALICE', 'BIO', 'CMS', 'ENIGMA', 'FCC', 'GW', 'NGNU', 'PAL', 'RENO', 'TEM'];
    public readonly embedded = window.parent !== window;
    public connection: 'checking' | 'configured' | 'missing' | 'unavailable' | 'active' = 'checking';
    public checking = false;
    private sequence = 1;
    private pending: AbortController | null = null;
    private activeAnswer: ChatMessage | null = null;
    private healthRequest: AbortController | null = null;
    private noticeTimer: ReturnType<typeof setTimeout> | null = null;
    private destroyed = false;
    private previousTitle = '';
    private typingFrame: number | null = null;
    private jumpUntil = 0;
    private reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    public async ngOnInit() {
        await this.service.init();
        this.previousTitle = document.title;
        document.title = 'GSDC 연구지원 도우미';
        await this.service.render();
        this.portalReady = true;
        this.postPortal({ type: 'GSDC_CHAT_READY', version: 1 });
        await this.refreshStatus();
    }


    private postPortal(message: object) {
        if (!this.destroyed && window.parent !== window)
            window.parent.postMessage(message, this.portalOrigin);
    }

    @HostListener('window:message', ['$event'])
    public onPortalMessage(event: MessageEvent) {
        if (this.destroyed || !this.portalReady || window.parent === window
            || event.origin !== this.portalOrigin || event.source !== window.parent) return;
        const data = event.data;
        if (!data || typeof data !== 'object' || Array.isArray(data)) return;
        if (data.type === 'GSDC_CHAT_INIT' && data.version === 1) {
            this.postPortal({ type: 'GSDC_CHAT_READY', version: 1 });
            return;
        }
        if (data.type !== 'GSDC_PORTAL_CONTEXT') return;
        const validId = data.requestId === undefined ||
            (typeof data.requestId === 'string' && /^[a-zA-Z0-9_.:-]{1,64}$/.test(data.requestId));
        const requestId = validId ? data.requestId : undefined;
        let community: string | null = null;
        let valid = data.version === 1 && validId;
        if (data.community === null) community = null;
        else if (typeof data.community === 'string' && data.community.length <= 32) {
            community = data.community.trim().toUpperCase();
            if (community === 'KIAF') community = 'ALICE';
            if (community === 'GSDC') community = null;
            else if (!this.communities.includes(community)) valid = false;
        } else valid = false;
        if (!valid) {
            this.postPortal({ type: 'GSDC_PORTAL_CONTEXT_ERROR', version: 1,
                requestId, code: 'invalid_context' });
            return;
        }
        const changed = this.portalCommunity !== community;
        this.portalCommunity = community;
        if (changed) {
            this.cancelPending();
            this.messages = [];
            this.input = '';
            this.followLatest = true;
            void this.service.render().then(() => this.resizeInput(true));
            void this.notify(community ? community + ' 매뉴얼을 기준으로 안내할게요.' : '커뮤니티 선택이 해제됐어요.');
        }
        this.postPortal({ type: 'GSDC_PORTAL_CONTEXT_ACK', version: 1,
            requestId, community, reset: changed });
    }

    public async refreshStatus() {
        if (this.checking) return;
        this.checking = true;
        const controller = new AbortController();
        this.healthRequest = controller;
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
            const response = await fetch('/api/chat/status', { cache: 'no-store', signal: controller.signal });
            if (!response.ok || !(response.headers.get('Content-Type') || '').includes('application/json')) throw new Error();
            const status = await response.json();
            if (!this.destroyed) {
                this.connection = status.configured ? 'configured' : 'missing';
                this.knowledgeReady = !status.retrieval || !!status.knowledge?.ready;
            }
        } catch {
            if (!this.destroyed) this.connection = 'unavailable';
        } finally {
            clearTimeout(timer);
            this.checking = false;
            if (this.healthRequest === controller) this.healthRequest = null;
            if (!this.destroyed) await this.service.render();
        }
    }

    private context(question: string): { role: string; content: string }[] {
        const pairs: { role: string; content: string }[][] = [];
        for (let i = 0; i < this.messages.length - 1; i++) {
            const user = this.messages[i], answer = this.messages[i + 1];
            if (user.role === 'user' && answer.role === 'assistant' && answer.state === 'complete') {
                pairs.push([{ role: 'user', content: user.text }, { role: 'assistant', content: answer.text }]);
            }
        }
        let size = question.length;
        const history: { role: string; content: string }[] = [];
        for (const pair of pairs.slice(-10).reverse()) {
            const count = pair[0].content.length + pair[1].content.length;
            if (size + count > 32000) break;
            size += count;
            history.unshift(...pair);
        }
        return [...history, { role: 'user', content: question }];
    }

    public async send(question?: string) {
        const text = (question || this.input).trim().slice(0, 2000);
        if (!text || this.loading || this.destroyed) return;
        const history = this.context(text);
        this.followLatest = true;
        this.input = '';
        this.resizeInput(true);
        this.messages.push({ id: ++this.sequence, role: 'user', text });
        const answer: ChatMessage = { id: ++this.sequence, role: 'assistant', text: '', displayText: '', state: 'streaming' };
        this.messages.push(answer);
        const controller = new AbortController();
        this.pending = controller;
        this.activeAnswer = answer;
        this.loading = true;
        let timedOut = false;
        const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 140000);
        let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
        try {
            await this.renderAndScroll();
            if (this.pending !== controller) return;
            const response = await fetch('/api/chat/stream', {
                method: 'POST', signal: controller.signal, credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-GSDC-Chat': '1' },
                body: JSON.stringify({ messages: history, community: this.portalCommunity })
            });
            if (this.pending !== controller) return;
            if (!response.ok) {
                const data = await response.json().catch(() => null);
                if (data?.error?.code === 'not_configured') this.connection = 'missing';
                answer.state = 'error';
                answer.error = data?.error?.message || '요청을 처리할 수 없어요. 잠시 후 다시 시도해 주세요.';
                return;
            }
            if (!response.body || !(response.headers.get('Content-Type') || '').includes('text/event-stream')) {
                throw new Error('invalid_stream');
            }
            reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '', terminal = false;
            while (!terminal) {
                const chunk = await reader.read();
                if (this.pending !== controller || this.destroyed) return;
                buffer += decoder.decode(chunk.value || new Uint8Array(), { stream: !chunk.done });
                buffer = buffer.replace(/\r\n/g, '\n');
                let boundary: number;
                while ((boundary = buffer.indexOf('\n\n')) >= 0) {
                    const frame = buffer.slice(0, boundary);
                    buffer = buffer.slice(boundary + 2);
                    const data = frame.split('\n').filter(line => line.startsWith('data:'))
                        .map(line => line.slice(5).trimStart()).join('\n');
                    if (!data) continue;
                    const event = JSON.parse(data);
                    if (event.type === 'delta' && typeof event.text === 'string') {
                        answer.text += event.text;
                        this.connection = 'active';
                        this.queueTyping(answer);
                    } else if (event.type === 'sources') {
                        answer.sources = (Array.isArray(event.sources) ? event.sources : [])
                            .filter((source: ChatSource) => typeof source.url === 'string' && source.url.startsWith('https://portal.gsdc.kr/'));
                        await this.renderAndScroll();
                    } else if (event.type === 'done') {
                        const cited = new Set(Array.from(answer.text.matchAll(/\[(\d+)\]/g), match => Number(match[1])));
                        answer.sources = (answer.sources || []).filter(source => cited.has(source.number));
                        answer.state = 'complete';
                        terminal = true;
                    } else if (event.type === 'error') {
                        answer.state = 'error';
                        answer.error = event.message || '답변을 완료하지 못했어요. 다시 시도해 주세요.';
                        terminal = true;
                    }
                    if (terminal) break;
                }
                if (chunk.done) {
                    if (!terminal) throw new Error('stream_interrupted');
                    break;
                }
            }
        } catch {
            if (this.pending !== controller || this.destroyed) return;
            answer.state = 'error';
            answer.error = timedOut ? '응답 시간이 초과됐어요. 다시 시도해 주세요.'
                : '응답 연결이 끊겼어요. 네트워크를 확인하고 다시 시도해 주세요.';
        } finally {
            clearTimeout(timer);
            if (reader) { try { await reader.cancel(); } catch {} reader.releaseLock(); }
            if (this.pending === controller) {
                this.finishTyping(answer);
                this.pending = null;
                this.activeAnswer = null;
                this.loading = false;
                if (!this.destroyed) await this.renderAndScroll();
            }
        }
    }

    public async retry(message: ChatMessage) {
        const index = this.messages.indexOf(message);
        const previous = this.messages[index - 1];
        if (previous?.role === 'user') await this.send(previous.text);
    }

    public displayed(message: ChatMessage): string {
        return message.displayText === undefined ? message.text : message.displayText;
    }


    private formattedCache = new WeakMap<ChatMessage, { text: string; html: string }>();

    // Escape every model character before adding a small set of owned HTML tags.
    // Angular sanitizes the result again; never bypass its HTML sanitizer.
    public formatted(message: ChatMessage): string {
        const text = this.displayed(message);
        const cached = this.formattedCache.get(message);
        if (cached?.text === text) return cached.html;
        const escape = (value: string) => value.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        const inline = (value: string) => value.split(/(\x60[^\x60]+\x60|\*\*[^*]+\*\*)/g).map(part => {
            if (part.startsWith(String.fromCharCode(96)) && part.endsWith(String.fromCharCode(96)))
                return '<code>' + escape(part.slice(1, -1)) + '</code>';
            if (part.startsWith('**') && part.endsWith('**'))
                return '<strong>' + escape(part.slice(2, -2)) + '</strong>';
            return escape(part);
        }).join('');
        const lines = text.replace(/\r\n/g, '\n').split('\n');
        const fence = String.fromCharCode(96).repeat(3);
        const output: string[] = [];
        let i = 0;
        const listItem = (line: string) => line.match(/^\s*(\d+[.)]|[-*•])\s+(.+)$/);
        while (i < lines.length) {
            const line = lines[i];
            if (!line.trim()) { i++; continue; }
            if (line.trimStart().startsWith(fence)) {
                i++;
                const code: string[] = [];
                while (i < lines.length && !lines[i].trimStart().startsWith(fence)) code.push(lines[i++]);
                if (i < lines.length) i++;
                output.push('<pre><code>' + escape(code.join('\n')) + '</code></pre>');
                continue;
            }
            const heading = line.match(/^#{1,4}\s+(.+)$/);
            if (heading) { output.push('<h3>' + inline(heading[1]) + '</h3>'); i++; continue; }
            const item = listItem(line);
            if (item) {
                const ordered = /^\d/.test(item[1]);
                const tag = ordered ? 'ol' : 'ul';
                const start = ordered ? ' start="' + parseInt(item[1], 10) + '"' : '';
                output.push('<' + tag + start + '>');
                while (i < lines.length) {
                    const next = listItem(lines[i]);
                    if (!next || /^\d/.test(next[1]) !== ordered) break;
                    output.push('<li>' + inline(next[2]) + '</li>');
                    i++;
                }
                output.push('</' + tag + '>');
                continue;
            }
            const paragraph: string[] = [];
            while (i < lines.length && lines[i].trim() && !listItem(lines[i])
                && !/^#{1,4}\s/.test(lines[i]) && !lines[i].trimStart().startsWith(fence))
                paragraph.push(inline(lines[i++]));
            output.push('<p>' + paragraph.join('<br>') + '</p>');
        }
        const html = output.join('');
        this.formattedCache.set(message, { text, html });
        return html;
    }

    // Smooth uneven network chunks without slowing down the network reader.
    private queueTyping(answer: ChatMessage) {
        if (this.reducedMotion || document.hidden) {
            this.finishTyping(answer);
            void this.renderAndScroll();
            return;
        }
        if (this.typingFrame !== null) return;
        const paint = async () => {
            this.typingFrame = null;
            if (this.destroyed || this.activeAnswer !== answer) return;
            const shown = answer.displayText?.length || 0;
            const remaining = answer.text.length - shown;
            let end = Math.min(answer.text.length, shown + Math.max(2, Math.ceil(remaining / 5)));
            // Never split a UTF-16 surrogate pair between frames.
            if (end < answer.text.length && answer.text.charCodeAt(end - 1) >= 0xD800 && answer.text.charCodeAt(end - 1) <= 0xDBFF) end++;
            answer.displayText = answer.text.slice(0, end);
            await this.renderAndScroll();
            if (!this.destroyed && this.activeAnswer === answer && this.typingFrame === null && end < answer.text.length) {
                this.typingFrame = requestAnimationFrame(paint);
            }
        };
        this.typingFrame = requestAnimationFrame(paint);
    }

    private finishTyping(answer: ChatMessage) {
        if (this.typingFrame !== null) cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
        answer.displayText = answer.text;
    }

    @HostListener('document:visibilitychange')
    public onVisibilityChange() {
        if (document.hidden && this.activeAnswer) this.finishTyping(this.activeAnswer);
    }

    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey && !event.isComposing && event.keyCode !== 229) {
            event.preventDefault();
            this.send();
        }
    }

    public async onInput(event: Event) {
        this.input = (event.target as HTMLTextAreaElement).value;
        this.resizeInput();
        await this.service.render();
    }

    public resizeInput(reset = false) {
        const element = this.composer?.nativeElement;
        if (!element) return;
        if (reset) element.value = this.input;
        element.style.height = 'auto';
        element.style.height = Math.min(element.scrollHeight, 120) + 'px';
    }

    public async stop() {
        this.cancelPending();
        await this.renderAndScroll();
    }

    public async newChat() {
        this.cancelPending();
        this.messages = [];
        this.input = '';
        this.followLatest = true;
        await this.service.render();
        this.resizeInput(true);
        this.composer?.nativeElement.focus();
    }

    private cancelPending() {
        if (this.typingFrame !== null) cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
        if (this.activeAnswer?.state === 'streaming') {
            this.activeAnswer.text = this.activeAnswer.displayText || '';
            this.activeAnswer.state = 'stopped';
            this.activeAnswer.error = '응답을 중지했어요.';
        }
        this.pending?.abort();
        this.pending = null;
        this.activeAnswer = null;
        this.loading = false;
    }

    public async onScroll() {
        if (performance.now() < this.jumpUntil) return;
        const element = this.messageScroll?.nativeElement;
        if (!element) return;
        const following = element.scrollHeight - element.scrollTop - element.clientHeight < 60;
        if (following !== this.followLatest) {
            this.followLatest = following;
            await this.service.render();
        }
    }

    public onScrollIntent() { this.jumpUntil = 0; }

    public async jumpToLatest() {
        this.followLatest = true;
        this.jumpUntil = performance.now() + 600;
        await this.service.render();
        const element = this.messageScroll?.nativeElement;
        element?.scrollTo({ top: element.scrollHeight, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    public async copy(message: ChatMessage) {
        const value = message.text;
        try {
            await navigator.clipboard.writeText(value);
            this.copiedId = message.id;
            await this.notify('답변을 복사했어요.');
        } catch { await this.notify('복사할 수 없어요. 답변을 선택해서 복사해 주세요.'); }
    }

    private async notify(text: string) {
        if (this.noticeTimer) clearTimeout(this.noticeTimer);
        this.notice = text;
        await this.service.render();
        this.noticeTimer = setTimeout(async () => {
            if (this.destroyed) return;
            this.notice = '';
            this.copiedId = null;
            await this.service.render();
        }, 2600);
    }

    private async renderAndScroll() {
        await this.service.render();
        const element = this.messageScroll?.nativeElement;
        if (element && this.followLatest) element.scrollTop = element.scrollHeight;
    }

    public trackMessage(index: number, message: ChatMessage) { return message.id; }

    public ngOnDestroy() {
        this.destroyed = true;
        this.healthRequest?.abort();
        this.cancelPending();
        if (this.noticeTimer) clearTimeout(this.noticeTimer);
        document.title = this.previousTitle;
    }
}

export default PageChatComponent;